import React from 'react';
import styles from '../Operations.module.css';

interface OPTIComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * CAMPAIGNOPTIN - Campaign Opt-In %
 * KPI information component
 */
const OPTI: OPTIComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Campaign Opt-In % represents the percentage of Ace Rewards National campaigns that a retailer is supporting via direct mail, email or text communications in the current calendar year.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Retailers can manage to their Ace Rewards National Campaign participation through ACENET (Marketing&gt; Ace Rewards Maintenance&gt; Promotions).<br/><br/>
        The Change Deadline column will indicate when participation changes to a campaign are no longer possible.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        90%
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        Manage Ace Rewards calendar on ACENET&gt; Marketing&gt; Ace Rewards Maintenance&gt; Promotions
      </div>
    </div>
  );
};

OPTI.title = 'Campaign Opt-In % - Ace Rewards';
OPTI.actionTitle = 'Update Campaign Opt-In';
OPTI.actionHyperlink = 'dynamicURL:ACENET:current';
export default OPTI;

